(function () {
  function initBulkBuilder(builder) {
    if (!builder || builder.dataset.redesignReady === 'true') return;

    var section = builder.closest('[data-section-id]') || builder.closest('section') || document;
    var artworkPilot = section.hasAttribute('data-unified-apparel');
    var pricing = window.DIYPrintPricing;
    var printProfile = pricing ? pricing.profile(section) : null;
    var modeWrap = section.querySelector('[data-diy-product-mode]');
    var singleForm = section.querySelector('.diy-main-product__form');
    if (!modeWrap || !singleForm) return;
    var minimumQuantity = Math.max(1, Number(singleForm.querySelector('[name="quantity"]')?.min) || 1);
    builder.dataset.redesignReady = 'true';

    var bulkEditGroupId = new URL(window.location.href).searchParams.get('bulk_edit');
    var colourIndex = Number(builder.dataset.colourIndex);
    var sizeIndex = Number(builder.dataset.sizeIndex);
    var colourPosition = colourIndex + 1;
    var sizePosition = sizeIndex + 1;
    var matrix = builder.querySelector('[data-bulk-matrix]');
    var summary = builder.querySelector('[data-bulk-summary]');
    var errorBox = builder.querySelector('[data-bulk-error]');
    var placementError = builder.querySelector('[data-bulk-placement-error]');
    var bulkAdd = builder.querySelector('[data-bulk-add]');
    var sharedOptions = builder.querySelector('[data-bulk-shared-options]');
    var colourList = builder.querySelector('[data-bulk-colours]');
    var colourSummary = builder.querySelector('[data-bulk-colour-summary]');
    var colourSearchWrap = builder.querySelector('[data-bulk-colour-search-wrap]');
    var colourSearch = builder.querySelector('[data-bulk-colour-search]');
    var showAllColours = builder.querySelector('[data-bulk-show-colours]');
    var printTarget = builder.querySelector('[data-bulk-print-area]');
    var uploadEmpty = builder.querySelector('[data-bulk-upload-empty]');
    var uploadHelper = builder.querySelector('[data-bulk-upload-helper]');
    var frontArtwork = builder.querySelector('[data-bulk-front-artwork]');
    var backArtwork = builder.querySelector('[data-bulk-back-artwork]');
    var noArtwork = builder.querySelector('[data-bulk-no-artwork]');
    var proofChoiceWrap = builder.querySelector('[data-bulk-proof-choice]');
    var proofChoices = proofChoiceWrap ? Array.from(proofChoiceWrap.querySelectorAll('[data-bulk-proof-choice]')) : [];
    var proofNote = proofChoiceWrap && proofChoiceWrap.querySelector('[data-bulk-proof-note]');
    var wasBlankProofState = null;
    var instructionsToggle = builder.querySelector('[data-bulk-instructions-toggle]');
    var instructions = builder.querySelector('[data-bulk-instructions]');
    var artworkNotes = builder.querySelector('[data-bulk-artwork-notes]');
    var orderSummary = builder.querySelector('[data-bulk-order-summary]');
    var variantData = builder.querySelector('[data-bulk-variants]');
    var bulkVariants = JSON.parse((variantData && variantData.textContent) || '[]');
    var selects = Array.prototype.slice.call(section.querySelectorAll('.diy-main-product__variants .diy-main-product__select'));
    var colourSelect = section.querySelector('.diy-main-product__variants .diy-main-product__select[data-option-position="' + colourPosition + '"]');
    var sizeSelect = section.querySelector('.diy-main-product__variants .diy-main-product__select[data-option-position="' + sizePosition + '"]');
    var placementSource = singleForm.querySelector('[data-placement-options]');
    var colourButtons = Array.prototype.slice.call(section.querySelectorAll('[data-option-button]')).filter(function (button) {
      return Number(button.dataset.optionIndex) === colourIndex;
    });
    var colours = colourSelect ? Array.from(colourSelect.options).map(function (option) { return option.value; }) : [];
    var sizes = sizeSelect ? Array.from(sizeSelect.options).map(function (option) { return option.value; }) : [''];
    var selectedColours = new Set();
    var colourExpanded = false;
    var colourLimit = 12;
    var uploadPreviewUrls = {};
    var submitting = false;
    var pilotUploadTemplate = artworkPilot ? builder.querySelector('[data-bulk-upload-slot="front"]').cloneNode(true) : null;
    if (artworkPilot) builder.querySelector('[data-bulk-upload-slots]').replaceChildren();

    if (!matrix || !summary || !bulkAdd || !colourList || !colourSelect || !colours.length || !sizes.length) return;

    function escapeHtml(value) {
      return String(value).replace(/[&<>"']/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[character];
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents);
      }
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    function formatBytes(size) {
      if (!size) return '';
      if (size < 1024 * 1024) return Math.max(1, Math.round(size / 1024)) + ' KB';
      return (size / 1024 / 1024).toFixed(1) + ' MB';
    }

    function colourButtonFor(colour) {
      return colourButtons.find(function (button) {
        return button.dataset.optionValue === colour;
      });
    }

    function swatchHtml(colour) {
      var source = colourButtonFor(colour);
      var swatch = source ? source.querySelector('.diy-option-button__swatch') : null;
      if (swatch) return swatch.outerHTML;
      return '<span class="diy-option-button__swatch" style="--swatch-colour: #d1d5db;" aria-hidden="true"></span>';
    }

    function getSharedSelections() {
      var selected = [];
      selects.forEach(function (select) {
        selected[Number(select.dataset.optionPosition) - 1] = select.value;
      });
      return selected;
    }

    function variantFor(colour, size) {
      var selected = getSharedSelections();
      // Match this bulk order's print selection independently of the single-item form.
      selects.forEach(function (select) {
        if (!Array.from(select.options).some(function (option) { return option.value === 'Blank / No print'; })) return;
        var placements = selectedPlacements();
        var printedOptions = Array.from(select.options).filter(function (option) { return option.value !== 'Blank / No print'; });
        var matching = printedOptions.find(function (option) { return placements.indexOf(option.value) !== -1; });
        selected[Number(select.dataset.optionPosition) - 1] = placements.length
          ? (matching || printedOptions[0]).value : 'Blank / No print';
      });
      return bulkVariants.find(function (variant) {
        return variant.options[colourIndex] === colour &&
          (sizeIndex < 0 || variant.options[sizeIndex] === size) &&
          variant.options.every(function (value, index) {
            return index === colourIndex || index === sizeIndex || selected[index] === value;
          });
      });
    }

    var bulkDiscountTiers = [
      { minimum: 1, maximum: 10, extraPercent: 0 },
      { minimum: 11, maximum: 19, extraPercent: 5 },
      { minimum: 20, maximum: 30, extraPercent: 8 },
      { minimum: 31, maximum: 40, extraPercent: 11 },
      { minimum: 41, maximum: 50, extraPercent: 13 },
      { minimum: 51, maximum: 60, extraPercent: 15 },
      { minimum: 61, maximum: 70, extraPercent: 17 },
      { minimum: 71, maximum: Infinity, extraPercent: 20 }
    ];

    function bulkTierFor(totalQuantity) {
      return bulkDiscountTiers.find(function (tier) {
        return totalQuantity >= tier.minimum && totalQuantity <= tier.maximum;
      }) || bulkDiscountTiers[0];
    }

    function lineTotalFor(variant, quantity, totalQuantity) {
      var tier = bulkTierFor(totalQuantity);
      var price = Number(variant.price || 0);
      var compareAtPrice = Number(variant.compare_at_price || 0);
      var storewidePrice = compareAtPrice > price ? price : Math.round(price * 0.8);
      // Shopify rounds the per-unit percentage discount down to whole cents.
      return (storewidePrice - Math.floor(storewidePrice * tier.extraPercent / 100)) * quantity;
    }

    function getQuantityInputs() {
      return Array.from(builder.querySelectorAll('[data-bulk-quantity]'));
    }

    function currentBulkItems() {
      var itemsByVariant = {};
      getQuantityInputs().forEach(function (input) {
        var quantity = Math.max(0, Number(input.value) || 0);
        var variant = bulkVariants.find(function (item) {
          return String(item.id) === input.dataset.variantId;
        });
        if (!variant || quantity < 1) return;
        itemsByVariant[variant.id] = { variant: variant, quantity: quantity };
      });
      return Object.keys(itemsByVariant).map(function (key) {
        return itemsByVariant[key];
      });
    }

    function quantitiesByColour() {
      var totals = {};
      var counted = new Set();
      getQuantityInputs().forEach(function (input) {
        if (counted.has(input.dataset.variantId)) return;
        counted.add(input.dataset.variantId);
        var quantity = Math.max(0, Number(input.value) || 0);
        if (!input.dataset.colour) return;
        totals[input.dataset.colour] = (totals[input.dataset.colour] || 0) + quantity;
      });
      return totals;
    }

    function selectedPlacements() {
      if (!printTarget) return [];
      return Array.from(printTarget.querySelectorAll('[data-placement-checkbox]')).filter(function (checkbox) {
        return checkbox.checked;
      }).map(function (checkbox) {
        return checkbox.value;
      });
    }

    function selectedPlacementText() {
      var placements = selectedPlacements();
      return placements.length ? placements.join(', ') : 'No print selected';
    }

    function needsBackArtwork(placements) {
      return placements.some(function (placement) {
        return placement.toLowerCase().indexOf('back') !== -1;
      });
    }

    function needsFrontArtwork(placements) {
      if (!placements.length) return false;
      return placements.some(function (placement) {
        var text = placement.toLowerCase();
        return text.indexOf('front') !== -1 || text.indexOf('chest') !== -1 || text.indexOf('panel') !== -1 || text.indexOf('back') === -1;
      });
    }

    function clearBulkError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.hidden = true;
    }

    function showBulkError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
    }

    function showPlacementError(message) {
      if (!placementError) return;
      placementError.textContent = message;
      placementError.hidden = !message;
    }

    function setMode(nextMode) {
      singleForm.hidden = nextMode === 'bulk';
      builder.hidden = nextMode !== 'bulk';
      modeWrap.querySelectorAll('[data-diy-mode]').forEach(function (button) {
        var isActive = button.dataset.diyMode === nextMode;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      if (nextMode === 'bulk') {
        if (!selectedColours.size) selectedColours.add(colourSelect.value || colours[0]);
        renderColourPicker();
        renderBulkMatrix();
        updateArtworkSlots();
      }
    }

    function renderSharedOptions() {
      if (!sharedOptions) return;
      sharedOptions.innerHTML = '';
      selects.forEach(function (select) {
        var index = Number(select.dataset.optionPosition) - 1;
        if (index === colourIndex || index === sizeIndex) return;
        var sourceOption = select.closest('.diy-main-product__option');
        var sourceLabel = sourceOption ? sourceOption.querySelector('.diy-option-label span, label') : null;
        var labelText = sourceLabel ? sourceLabel.textContent.trim() : 'Option';
        if (/^print\s+(area|location|placement|position)$/i.test(labelText)) return;
        var field = document.createElement('div');
        field.className = 'diy-main-product__option';
        var label = document.createElement('label');
        label.textContent = labelText;
        var clone = select.cloneNode(true);
        clone.classList.remove('diy-main-product__select--hidden');
        clone.removeAttribute('id');
        clone.removeAttribute('aria-hidden');
        clone.removeAttribute('tabindex');
        clone.addEventListener('change', function () {
          select.value = clone.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          renderBulkMatrix();
        });
        field.append(label, clone);
        sharedOptions.appendChild(field);
      });
    }

    function renderColourPicker() {
      var query = colourSearch ? colourSearch.value.trim().toLowerCase() : '';
      var visibleColours = colours.filter(function (colour) {
        return !query || colour.toLowerCase().indexOf(query) !== -1;
      });
      var clipped = !query && !colourExpanded && visibleColours.length > colourLimit;
      var renderedColours = clipped ? visibleColours.slice(0, colourLimit) : visibleColours;
      colourList.innerHTML = renderedColours.map(function (colour) {
        var selected = selectedColours.has(colour);
        return '<button type="button" class="diy-option-button diy-option-button--colour diy-bulk-colour-button' + (selected ? ' is-selected' : '') + '" data-bulk-colour="' + escapeHtml(colour) + '" title="' + escapeHtml(colour) + '" aria-pressed="' + (selected ? 'true' : 'false') + '" aria-label="' + (selected ? 'Remove ' : 'Select ') + escapeHtml(colour) + '">' +
          swatchHtml(colour) +
          '<span>' + escapeHtml(colour) + '</span>' +
        '</button>';
      }).join('');
      if (colourSearchWrap) colourSearchWrap.hidden = colours.length <= colourLimit;
      if (showAllColours) {
        showAllColours.hidden = colours.length <= colourLimit || Boolean(query);
        showAllColours.textContent = colourExpanded ? 'Show fewer colours' : 'Show all ' + colours.length + ' colours';
      }
      updateBulkSummary();
    }

    function renderQuantityControl(variant, colour, size, value) {
      if (!variant) return '<td class="diy-main-product__bulk-cell diy-main-product__bulk-cell--disabled">—</td>';
      if (!variant.available) return '<td class="diy-main-product__bulk-cell diy-main-product__bulk-cell--disabled">Sold out</td>';
      return '<td class="diy-main-product__bulk-cell"><div class="diy-bulk-stepper' + (Number(value) > 0 ? ' is-active' : '') + '">' +
        '<button type="button" data-bulk-adjust="-1" data-variant-id="' + variant.id + '" aria-label="Decrease ' + escapeHtml(colour + ' ' + size) + ' quantity">−</button>' +
        '<input type="number" min="0" inputmode="numeric" data-bulk-quantity data-variant-id="' + variant.id + '" data-colour="' + escapeHtml(colour) + '" data-size="' + escapeHtml(size) + '" value="' + escapeHtml(value) + '" aria-label="' + escapeHtml(colour + ' ' + size + ' quantity') + '">' +
        '<button type="button" data-bulk-adjust="1" data-variant-id="' + variant.id + '" aria-label="Increase ' + escapeHtml(colour + ' ' + size) + ' quantity">+</button>' +
        '</div></td>';
    }

    function renderBulkMatrix() {
      var previousQuantities = {};
      getQuantityInputs().forEach(function (input) {
        previousQuantities[JSON.stringify([input.dataset.colour, input.dataset.size])] = input.value || '0';
      });
      var selected = colours.filter(function (colour) { return selectedColours.has(colour); });
      if (!selected.length) {
        matrix.innerHTML = '<p class="diy-bulk-builder__empty">Choose colours to start entering quantities.</p>';
        updateBulkSummary();
        return;
      }
      var desktopRows = selected.map(function (colour) {
        var rowTotal = 0;
        var cells = sizes.map(function (size) {
          var variant = variantFor(colour, size);
          var value = variant ? (previousQuantities[JSON.stringify([colour, size])] || '0') : '0';
          rowTotal += Number(value) || 0;
          return renderQuantityControl(variant, colour, size, value);
        }).join('');
        return '<tr><th scope="row"><span class="diy-bulk-row-label">' + swatchHtml(colour) + '<span>' + escapeHtml(colour) + '</span></span></th>' + cells + '<td class="diy-bulk-row-total" data-row-total="' + escapeHtml(colour) + '">' + rowTotal + '</td></tr>';
      }).join('');
      var mobileRows = selected.map(function (colour) {
        var rowTotal = 0;
        var fields = sizes.map(function (size) {
          var variant = variantFor(colour, size);
          var value = variant ? (previousQuantities[JSON.stringify([colour, size])] || '0') : '0';
          rowTotal += Number(value) || 0;
          if (!variant) return '<div class="diy-main-product__bulk-mobile-row"><span>' + escapeHtml(size) + '</span><span>—</span></div>';
          if (!variant.available) return '<div class="diy-main-product__bulk-mobile-row"><span>' + escapeHtml(size) + '</span><span>Sold out</span></div>';
          return '<div class="diy-main-product__bulk-mobile-row"><span>' + escapeHtml(size || 'Quantity') + '</span><div class="diy-bulk-stepper' + (Number(value) > 0 ? ' is-active' : '') + '">' +
            '<button type="button" data-bulk-adjust="-1" data-variant-id="' + variant.id + '" aria-label="Decrease ' + escapeHtml(colour + ' ' + size) + ' quantity">−</button>' +
            '<input type="number" min="0" inputmode="numeric" data-bulk-quantity data-variant-id="' + variant.id + '" data-colour="' + escapeHtml(colour) + '" data-size="' + escapeHtml(size) + '" value="' + escapeHtml(value) + '">' +
            '<button type="button" data-bulk-adjust="1" data-variant-id="' + variant.id + '" aria-label="Increase ' + escapeHtml(colour + ' ' + size) + ' quantity">+</button>' +
            '</div></div>';
        }).join('');
        return '<details class="diy-main-product__bulk-accordion" open><summary><span class="diy-bulk-row-label">' + swatchHtml(colour) + '<span>' + escapeHtml(colour) + '</span></span><strong data-mobile-row-total="' + escapeHtml(colour) + '">' + rowTotal + ' items</strong></summary><div class="diy-bulk-size-grid">' + fields + '</div></details>';
      }).join('');
      matrix.innerHTML = '<div class="diy-main-product__bulk-desktop"><table><thead><tr><th scope="col">Colour</th>' +
        sizes.map(function (size) { return '<th scope="col">' + escapeHtml(size || 'Quantity') + '</th>'; }).join('') +
        '<th scope="col">Total</th></tr></thead><tbody>' + desktopRows + '</tbody></table></div><div class="diy-main-product__bulk-mobile">' + mobileRows + '</div>';
      getQuantityInputs().forEach(function (input) {
        input.addEventListener('input', function () {
          getQuantityInputs().forEach(function (peer) {
            if (peer.dataset.variantId === input.dataset.variantId) peer.value = input.value;
          });
          updateBulkSummary();
        });
      });
      updateBulkSummary();
    }

    function updateBulkSummary() {
      var items = currentBulkItems();
      var qty = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      var totals = quantitiesByColour();
      var selected = colours.filter(function (colour) { return selectedColours.has(colour); });
      var estimatedTotal = items.reduce(function (sum, item) {
        return sum + lineTotalFor(item.variant, item.quantity, qty);
      }, 0);
      var printSurcharge = pricing && printProfile ? pricing.surcharge(printProfile, selectedPlacements()) : 0;
      estimatedTotal += printSurcharge * qty;
      getQuantityInputs().forEach(function (input) {
        var stepper = input.closest('.diy-bulk-stepper');
        if (stepper) stepper.classList.toggle('is-active', Number(input.value) > 0);
      });
      builder.querySelectorAll('[data-row-total]').forEach(function (cell) {
        cell.textContent = totals[cell.dataset.rowTotal] || 0;
      });
      builder.querySelectorAll('[data-mobile-row-total]').forEach(function (cell) {
        var count = totals[cell.dataset.mobileRowTotal] || 0;
        cell.textContent = count + ' item' + (count === 1 ? '' : 's');
      });
      if (!submitting) {
        bulkAdd.disabled = qty < minimumQuantity;
        bulkAdd.textContent = qty < minimumQuantity ? 'Minimum ' + minimumQuantity + (minimumQuantity === 1 ? ' item' : ' items') : 'Add ' + qty + (qty === 1 ? ' item' : ' items') + ' to cart';
      }
      if (colourSummary) colourSummary.textContent = selected.length + ' colour' + (selected.length === 1 ? '' : 's') + ' selected' + (qty ? ' · ' + qty + ' garments' : '') + '.';
      if (summary) {
        var tier = bulkTierFor(qty || 1);
        summary.textContent = qty < 1
          ? 'Total garments: 0'
          : 'Total garments: ' + qty + ' · Price includes 20% off + ' + tier.extraPercent + '% bulk discount · Estimated total: ' + formatMoney(estimatedTotal);
      }
      if (uploadHelper) uploadHelper.textContent = "Upload once — we'll apply it to all " + (qty || 'selected') + ' garment' + (qty === 1 ? '' : 's') + '.';
      syncProofChoice();
      if (orderSummary) {
        var rows = selected.filter(function (colour) { return (totals[colour] || 0) > 0; }).map(function (colour) {
          return '<li><span>' + swatchHtml(colour) + '<b>' + escapeHtml(colour) + '</b></span><strong>' + totals[colour] + '</strong></li>';
        }).join('');
        orderSummary.innerHTML = (rows ? '<ul>' + rows + '</ul>' : '<p class="diy-bulk-builder__muted">No quantities selected yet.</p>') +
          '<dl><div><dt>Total garments</dt><dd>' + qty + '</dd></div><div><dt>Print area</dt><dd>' + escapeHtml(selectedPlacementText()) + '</dd></div><div><dt>Discount tier</dt><dd>' + (qty ? 'Price includes 20% off + ' + bulkTierFor(qty).extraPercent + '% bulk' : '—') + '</dd></div><div><dt>Estimated total</dt><dd>' + (qty ? formatMoney(estimatedTotal) : '—') + '</dd></div></dl>';
        if (printSurcharge && qty) orderSummary.querySelector('dl').insertAdjacentHTML('afterbegin', '<div><dt>Print surcharge (before discounts)</dt><dd>' + formatMoney(printSurcharge) + ' × ' + qty + ' = ' + formatMoney(printSurcharge * qty) + '</dd></div>');
      }
    }

    function renderPrintArea() {
      if (!printTarget || !placementSource) return;
      var clone = placementSource.cloneNode(true);
      clone.classList.add('diy-bulk-placement-grid');
      clone.querySelectorAll('input').forEach(function (input) {
        if (artworkPilot && input.id) {
          var previousId = input.id;
          input.id = previousId + '-bulk';
          clone.querySelectorAll('label').forEach(function (label) {
            if (label.htmlFor === previousId) label.htmlFor = input.id;
          });
        }
        input.checked = false;
        input.removeAttribute('name');
        input.disabled = false;
      });
      printTarget.innerHTML = '';
      printTarget.appendChild(clone);
      if (artworkPilot && printProfile) clone.dataset.maxSelectedPositions = String(printProfile.maxSelectedPositions);
      clone.addEventListener('change', function (event) {
        var checkbox = event.target;
        if (!(checkbox instanceof HTMLInputElement) || !checkbox.matches('[data-placement-checkbox]')) return;
        var max = Number(clone.dataset.maxSelectedPositions) || 2;
        var checked = Array.from(clone.querySelectorAll('[data-placement-checkbox]')).filter(function (item) { return item.checked; });
        var position = printProfile && printProfile.positions.find(function (p) { return p.label === checkbox.value; });
        var groupCount = position && printProfile.positions.filter(function (p) {
          return p.group === position.group && checked.some(function (input) { return input.value === p.label; });
        }).length;
        if (position && position.maxPerGroup && groupCount > position.maxPerGroup) {
          checkbox.checked = false;
          showPlacementError('Choose one print position per side.');
          return;
        }
        if (checked.length > max) {
          checkbox.checked = false;
          showPlacementError('Choose up to ' + max + ' print positions.');
          return;
        }
        showPlacementError('');
        updateArtworkSlots();
        renderBulkMatrix();
        clearBulkError();
      });
    }

    function fileFor(slotName) {
      if (artworkPilot) {
        var slot = Array.from(builder.querySelectorAll('[data-bulk-upload-slot]')).find(function (node) { return node.dataset.bulkUploadSlot === slotName; });
        var pilotInput = slot && !slot.hidden && slot.querySelector('input[type="file"]');
        return pilotInput && pilotInput.files && pilotInput.files[0] || null;
      }
      var input = slotName === 'back' ? backArtwork : frontArtwork;
      return input && input.files && input.files[0] ? input.files[0] : null;
    }

    function setFileState(slot, file, state, message) {
      var box = slot.querySelector('[data-bulk-file-state]');
      var dropzone = slot.querySelector('[data-bulk-dropzone]');
      var slotName = slot.dataset.bulkUploadSlot;
      if (!box || !dropzone) return;
      if (uploadPreviewUrls[slotName]) {
        URL.revokeObjectURL(uploadPreviewUrls[slotName]);
        delete uploadPreviewUrls[slotName];
      }
      if (!file && state !== 'error') {
        box.hidden = true;
        dropzone.hidden = false;
        return;
      }
      var preview = '<span class="diy-bulk-upload-type">' + escapeHtml(file ? (file.name.split('.').pop() || 'file').toUpperCase() : '!') + '</span>';
      if (file && file.size <= 4 * 1024 * 1024 && /\.(png|jpe?g|webp|gif)$/i.test(file.name || '')) {
        uploadPreviewUrls[slotName] = URL.createObjectURL(file);
        preview = '<img src="' + uploadPreviewUrls[slotName] + '" alt="">';
      }
      var title = state === 'uploading' ? 'Uploading ' + (file ? file.name : 'file') + '...' : state === 'error' ? 'We could not upload this file.' : file.name;
      var detail = state === 'uploading' ? 'Please wait' : state === 'error' ? (message || 'Please try again.') : formatBytes(file.size);
      box.innerHTML = '<div class="diy-bulk-upload-file__preview">' + preview + '</div><div><strong>' + escapeHtml(title) + '</strong><small>' + escapeHtml(detail) + '</small></div><div class="diy-bulk-upload-file__actions"><button type="button" data-bulk-change-file="' + slotName + '">Change file</button><button type="button" data-bulk-remove-file="' + slotName + '">Remove</button></div>';
      box.hidden = false;
      dropzone.hidden = true;
      var image = box.querySelector('img');
      if (image) image.onerror = function () { image.hidden = true; };
    }

    function pilotFileSlots() {
      return Array.from(builder.querySelectorAll('[data-bulk-upload-slot]')).filter(function (slot) {
        return Boolean(fileFor(slot.dataset.bulkUploadSlot));
      });
    }

    function syncPilotUploads(placements) {
      var container = builder.querySelector('[data-bulk-upload-slots]');
      container.querySelectorAll('[data-pilot-artwork-group]').forEach(function (group) {
        if (placements.indexOf(group.dataset.pilotArtworkGroup) !== -1) return;
        group.querySelectorAll('[data-bulk-upload-slot]').forEach(function (slot) {
          var key = slot.dataset.bulkUploadSlot;
          slot.querySelector('input[type="file"]').value = '';
          if (uploadPreviewUrls[key]) URL.revokeObjectURL(uploadPreviewUrls[key]);
          delete uploadPreviewUrls[key];
        });
        group.remove();
      });
      placements.forEach(function (placement) {
        if (Array.from(container.children).some(function (group) { return group.dataset.pilotArtworkGroup === placement; })) return;
        var group = document.createElement('div');
        group.dataset.pilotArtworkGroup = placement;
        group.className = 'diy-bulk-artwork-group';
        var add;
        function addSlot(index) {
          var slot = pilotUploadTemplate.cloneNode(true);
          var key = 'position-' + placement.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + index;
          slot.hidden = false;
          slot.dataset.bulkUploadSlot = key;
          slot.dataset.artworkProperty = 'Artwork - ' + placement + (index > 1 ? ' 2' : '');
          slot.querySelector('h4').textContent = index === 1 ? 'Artwork for ' + placement : 'Additional artwork for ' + placement;
          var input = slot.querySelector('input[type="file"]');
          input.id = 'BulkArtwork-' + section.dataset.sectionId + '-' + key;
          input.value = '';
          slot.querySelector('label').htmlFor = input.id;
          if (index > 1) {
            var remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'diy-upload-slot__add diy-upload-slot__remove';
            remove.textContent = 'Remove this image';
            remove.setAttribute('aria-label', 'Remove additional artwork for ' + placement);
            remove.addEventListener('click', function () {
              input.value = '';
              if (uploadPreviewUrls[key]) URL.revokeObjectURL(uploadPreviewUrls[key]);
              delete uploadPreviewUrls[key];
              slot.remove();
              add.hidden = false;
            });
            slot.appendChild(remove);
          }
          group.appendChild(slot);
          initUploadSlot(slot);
        }
        addSlot(1);
        add = document.createElement('button');
        add.type = 'button';
        add.className = 'diy-upload-slot__add';
        add.textContent = '+ Add another image for ' + placement;
        add.addEventListener('click', function () {
          addSlot(2);
          add.hidden = true;
        });
        group.appendChild(add);
        container.appendChild(group);
      });
      printTarget.querySelectorAll('.diy-placement-card').forEach(function (card) {
        card.classList.toggle('is-selected', Boolean(card.querySelector('input:checked')));
      });
      var artworkSection = builder.querySelector('[data-bulk-artwork-section]');
      if (artworkSection) artworkSection.hidden = placements.length === 0;
    }

    function updateArtworkSlots() {
      var placements = selectedPlacements();
      if (artworkPilot) {
        syncPilotUploads(placements);
        return;
      }
      var frontSlot = builder.querySelector('[data-bulk-upload-slot="front"]');
      var backSlot = builder.querySelector('[data-bulk-upload-slot="back"]');
      var showFront = needsFrontArtwork(placements);
      var showBack = needsBackArtwork(placements);
      if (frontSlot) frontSlot.hidden = !showFront;
      if (backSlot) backSlot.hidden = !showBack;
      if (uploadEmpty) uploadEmpty.hidden = showFront || showBack;
      var artworkSection = builder.querySelector('[data-bulk-artwork-section]');
      if (artworkSection) artworkSection.hidden = !showFront && !showBack;
    }

    function initUploadSlot(slot) {
      var input = slot.querySelector('input[type="file"]');
      var dropzone = slot.querySelector('[data-bulk-dropzone]');
      if (!input || !dropzone) return;
      input.removeAttribute('accept');
      input.addEventListener('change', function () {
        setFileState(slot, input.files && input.files[0] ? input.files[0] : null);
        clearBulkError();
      });
      ['dragenter', 'dragover'].forEach(function (eventName) {
        dropzone.addEventListener(eventName, function (event) {
          event.preventDefault();
          dropzone.classList.add('is-dragging');
        });
      });
      ['dragleave', 'drop'].forEach(function (eventName) {
        dropzone.addEventListener(eventName, function (event) {
          event.preventDefault();
          dropzone.classList.remove('is-dragging');
        });
      });
      dropzone.addEventListener('drop', function (event) {
        var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (!file) return;
        if (window.DataTransfer) {
          var transfer = new DataTransfer();
          transfer.items.add(file);
          input.files = transfer.files;
        }
        setFileState(slot, file);
        clearBulkError();
      });
    }

    function validateArtwork() {
      var placements = selectedPlacements();
      if (artworkPilot) {
        if (!placements.length && printProfile && (printProfile.printRequired || !printProfile.blankAllowed)) return 'Please choose a print area.';
        var missing = Array.from(builder.querySelectorAll('[data-pilot-artwork-group]')).find(function (group) {
          return !fileFor(group.querySelector('[data-bulk-upload-slot]').dataset.bulkUploadSlot);
        });
        return missing ? 'Please upload artwork for ' + missing.dataset.pilotArtworkGroup + '.' : '';
      }
      var placementConfig = printTarget ? printTarget.querySelector('[data-placement-options]') : null;
      var printRequired = placementConfig && placementConfig.dataset.printRequired === 'true';
      var blankAllowed = placementConfig && placementConfig.dataset.blankAllowed === 'true';
      if (!placements.length && printRequired) return 'Please choose a print area.';
      if (noArtwork && noArtwork.checked && blankAllowed) return '';
      if (needsFrontArtwork(placements) && !fileFor('front')) return 'Please upload front artwork or choose the send artwork later option.';
      if (needsBackArtwork(placements) && !fileFor('back')) return 'Please upload back artwork or choose the send artwork later option.';
      return '';
    }

    function proofIsNotRequired() {
      if (!selectedPlacements().length) return true;
      if (noArtwork && noArtwork.checked) return true;
      var selected = proofChoiceWrap && proofChoiceWrap.querySelector('[data-bulk-proof-choice]:checked');
      return Boolean(selected && selected.value === 'not_required');
    }

    function syncProofChoice() {
      var blank = selectedPlacements().length === 0;
      proofChoices.forEach(function (choice) {
        choice.disabled = Boolean(blank);
        if (blank) choice.checked = choice.value === 'not_required';
      });
      if (!blank && wasBlankProofState === true) {
        proofChoices.forEach(function (choice) { choice.checked = choice.value === 'required'; });
      }
      wasBlankProofState = Boolean(blank);
      if (proofNote) proofNote.textContent = blank || proofIsNotRequired()
        ? 'No proof will be required before production for this bulk order.'
        : 'Production will not start until the selected proof is approved.';
    }

    function propertiesFor(groupId, qty, updatedAt) {
      var frontFile = fileFor('front');
      var backFile = fileFor('back');
      var frontName = frontFile ? frontFile.name : '';
      var backName = backFile ? backFile.name : '';
      var notes = artworkNotes && artworkNotes.value ? artworkNotes.value.trim() : '';
      var placement = selectedPlacementText();
      var tier = bulkTierFor(qty);
      var proofSkipped = proofIsNotRequired();
      var properties = {
        'Order type': 'Bulk order',
        'Print location': placement,
        'Front artwork': frontName || (noArtwork && noArtwork.checked ? 'Customer will send later' : ''),
        'Back artwork': backName || '',
        'Artwork notes': notes,
        'Proof approval': proofSkipped ? 'Proof not required - customer accepted faster processing' : 'Proof required',
        'Discount rule': 'Storewide 20% + ' + tier.extraPercent + '% bulk discount (' + tier.minimum + '-' + (tier.maximum === Infinity ? 'plus' : tier.maximum) + ' garments)',
        '_bulk_group_id': groupId,
        '_order_type': 'bulk',
        '_bulk_discount_percent': String(tier.extraPercent),
        '_proof_required': proofSkipped ? 'false' : 'true',
        '_bulk_total_quantity': String(qty),
        '_bulk_updated_at': updatedAt
      };
      Object.keys(properties).forEach(function (key) {
        if (properties[key] === '') delete properties[key];
      });
      if (artworkPilot) pilotFileSlots().forEach(function (slot) { properties[slot.dataset.artworkProperty] = fileFor(slot.dataset.bulkUploadSlot).name; });
      return properties;
    }

    function cartItemSignature(item) {
      var properties = item.properties || {};
      return String(item.variant_id) + JSON.stringify(Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; }));
    }

    async function removeCartKeys(previousItems) {
      if (!previousItems.length) return;
      // Discount recalculation can change line keys after adding the replacement.
      var currentResponse = await fetch('/cart.js', { cache: 'no-store' });
      if (!currentResponse.ok) throw new Error('Unable to verify the updated cart. Please review your cart before retrying.');
      var currentCart = await currentResponse.json();
      var updates = {};
      (currentCart.items || []).forEach(function (item) {
        if (previousItems.indexOf(cartItemSignature(item)) !== -1) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return;
      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      if (!response.ok) throw new Error('Unable to remove the previous quantities. Please review your cart before retrying.');
    }

    async function staleEditKeys(groupId) {
      if (!groupId) return [];
      var response = await fetch('/cart.js');
      var cart = await response.json();
      return (cart.items || []).filter(function (item) {
        return item.properties && (item.properties._bulk_group_id === groupId || item.properties._bulk_parent_group_id === groupId);
      }).map(cartItemSignature);
    }

    async function addFirstItemWithFiles(item, props) {
      var formData = new FormData();
      formData.append('id', item.variant.id);
      formData.append('quantity', item.quantity);
      var itemProps = propertiesForItem(item, props);
      Object.keys(itemProps).forEach(function (key) {
        formData.append('properties[' + key + ']', itemProps[key]);
      });
      if (artworkPilot) {
        pilotFileSlots().forEach(function (slot) {
          var file = fileFor(slot.dataset.bulkUploadSlot);
          formData.set('properties[' + slot.dataset.artworkProperty + ']', file, file.name);
        });
      } else {
        if (fileFor('front')) formData.append('properties[Front artwork file]', fileFor('front'), fileFor('front').name);
        if (fileFor('back')) formData.append('properties[Back artwork file]', fileFor('back'), fileFor('back').name);
      }
      return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    }

    function propertiesForItem(item, props) {
      return Object.assign({}, props, { _diyprint_link_id: props._bulk_group_id + '-' + props._bulk_updated_at + '-' + item.variant.id });
    }

    async function addJsonItems(items, props, addons) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items.map(function (item) { return { id: item.variant.id, quantity: item.quantity, properties: propertiesForItem(item, props) }; }).concat(addons || []) })
      });
    }

    async function assertCartResponse(response) {
      if (window.DIYPrintUploads) return window.DIYPrintUploads.readCartResponse(response);
      var result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add the bulk order.');
      return result;
    }

    async function addBulkOrder() {
      if (submitting) return;
      clearBulkError();
      showPlacementError('');
      var items = currentBulkItems();
      var qty = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (qty < minimumQuantity) return showBulkError('Minimum order: ' + minimumQuantity + (minimumQuantity === 1 ? ' item.' : ' items.'));
      if (!pricing || !printProfile) return showBulkError('Print pricing is unavailable. Please refresh and try again.');
      var artworkError = validateArtwork();
      if (artworkError) return showBulkError(artworkError);
      var groupId = bulkEditGroupId || ('bulk-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8));
      var oldKeys = [];
      var updatedAt = new Date().toISOString();
      var props = propertiesFor(groupId, qty, updatedAt);
      var addons;
      try {
        var surcharge = pricing.surcharge(printProfile, selectedPlacements());
        addons = items.flatMap(function (item) {
          return pricing.addonItems(printProfile, surcharge, item.quantity, propertiesForItem(item, props)._diyprint_link_id, selectedPlacementText());
        });
        addons.forEach(function (item) {
          item.properties._bulk_parent_group_id = groupId;
          item.properties._bulk_updated_at = updatedAt;
        });
      } catch (error) {
        return showBulkError(error.message || 'Unable to calculate print pricing.');
      }
      var hasFiles = artworkPilot ? pilotFileSlots().length > 0 : Boolean(fileFor('front') || fileFor('back'));
      var uploadSlots = Array.from(builder.querySelectorAll('[data-bulk-upload-slot]')).filter(function (slot) {
        return !slot.hidden && fileFor(slot.dataset.bulkUploadSlot);
      });
      submitting = true;
      bulkAdd.disabled = true;
      bulkAdd.textContent = bulkEditGroupId ? 'Updating...' : 'Adding...';
      uploadSlots.forEach(function (slot) { setFileState(slot, fileFor(slot.dataset.bulkUploadSlot), 'uploading'); });
      try {
        if (bulkEditGroupId) oldKeys = await staleEditKeys(bulkEditGroupId);
        if (hasFiles) {
          await assertCartResponse(await addFirstItemWithFiles(items[0], props));
          if (items.length > 1 || addons.length) await assertCartResponse(await addJsonItems(items.slice(1), props, addons));
        } else {
          await assertCartResponse(await addJsonItems(items, props, addons));
        }
        await removeCartKeys(oldKeys);
        window.location.href = builder.dataset.cartUrl || '/cart';
      } catch (error) {
        try {
          var recovery = await fetch('/cart.js', { cache: 'no-store' });
          if (!recovery.ok) throw new Error('Cart recovery unavailable');
          var recoveryCart = await recovery.json();
          var addedSignatures = (recoveryCart.items || []).filter(function (item) {
            var p = item.properties || {};
            return (p._bulk_group_id === groupId || p._bulk_parent_group_id === groupId) && p._bulk_updated_at === updatedAt;
          }).map(cartItemSignature);
          await removeCartKeys(addedSignatures);
        } catch (recoveryError) {
          error.message += ' Please check your cart before retrying; some items may have been added.';
        }
        submitting = false;
        bulkAdd.disabled = false;
        bulkAdd.textContent = bulkEditGroupId ? 'Update bulk order' : 'Add ' + qty + ' items to cart';
        uploadSlots.forEach(function (slot) { setFileState(slot, fileFor(slot.dataset.bulkUploadSlot), 'error', error.message); });
        showBulkError(error.message || 'Unable to add the bulk order.');
      }
    }

    async function restoreBulkEdit() {
      if (!bulkEditGroupId) return;
      try {
        var response = await fetch('/cart.js');
        var cart = await response.json();
        var groupItems = (cart.items || []).filter(function (item) {
          return item.properties && item.properties._bulk_group_id === bulkEditGroupId;
        });
        if (!groupItems.length) return;
        var first = groupItems[0].properties || {};
        setMode('bulk');
        var savedPlacements = String(first['Print location'] || '').split(',').map(function (value) { return value.trim(); });
        printTarget.querySelectorAll('[data-placement-checkbox]').forEach(function (input) {
          input.checked = savedPlacements.indexOf(input.value) !== -1;
        });
        updateArtworkSlots();
        groupItems.forEach(function (item) {
          var variant = bulkVariants.find(function (candidate) { return candidate.id === item.variant_id; });
          if (variant && variant.options[colourIndex]) selectedColours.add(variant.options[colourIndex]);
        });
        renderColourPicker();
        renderBulkMatrix();
        groupItems.forEach(function (item) {
          var input = builder.querySelector('[data-bulk-quantity][data-variant-id="' + item.variant_id + '"]');
          if (input) {
            input.value = item.quantity;
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
        if (artworkNotes) artworkNotes.value = first['Artwork notes'] || '';
        bulkAdd.textContent = 'Update bulk order';
        updateBulkSummary();
      } catch (error) {}
    }

    modeWrap.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var button = event.target.closest('[data-diy-mode]');
      if (!button) return;
      setMode(button.dataset.diyMode);
    });
    colourList.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bulk-colour]');
      if (!button) return;
      var colour = button.dataset.bulkColour;
      var totals = quantitiesByColour();
      if (selectedColours.has(colour)) {
        if ((totals[colour] || 0) > 0 && !window.confirm('Remove ' + colour + ' and its selected items?')) return;
        selectedColours.delete(colour);
      } else {
        selectedColours.add(colour);
      }
      renderColourPicker();
      renderBulkMatrix();
      clearBulkError();
    });
    matrix.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bulk-adjust]');
      if (!button) return;
      var input = builder.querySelector('[data-bulk-quantity][data-variant-id="' + button.dataset.variantId + '"]');
      if (!input) return;
      input.value = Math.max(0, Number(input.value || 0) + Number(button.dataset.bulkAdjust));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    if (colourSearch) colourSearch.addEventListener('input', renderColourPicker);
    if (showAllColours) showAllColours.addEventListener('click', function () {
      colourExpanded = !colourExpanded;
      renderColourPicker();
    });
    if (bulkAdd) bulkAdd.addEventListener('click', addBulkOrder);
    if (noArtwork) noArtwork.addEventListener('change', function () { clearBulkError(); syncProofChoice(); });
    proofChoices.forEach(function (choice) { choice.addEventListener('change', syncProofChoice); });
    if (artworkNotes) artworkNotes.addEventListener('input', clearBulkError);
    if (instructionsToggle && instructions) {
      instructionsToggle.addEventListener('click', function () {
        var nextHidden = !instructions.hidden;
        instructions.hidden = nextHidden;
        instructionsToggle.setAttribute('aria-expanded', nextHidden ? 'false' : 'true');
        instructionsToggle.textContent = nextHidden ? '+ Add artwork instructions' : '− Hide artwork instructions';
      });
    }
    builder.querySelectorAll('[data-bulk-upload-slot]').forEach(initUploadSlot);
    builder.addEventListener('click', function (event) {
      var change = event.target.closest('[data-bulk-change-file]');
      var remove = event.target.closest('[data-bulk-remove-file]');
      if (change) {
        var changeInput = artworkPilot ? change.closest('[data-bulk-upload-slot]').querySelector('input[type="file"]') : change.dataset.bulkChangeFile === 'back' ? backArtwork : frontArtwork;
        if (changeInput) changeInput.click();
      }
      if (remove) {
        var removeInput = artworkPilot ? remove.closest('[data-bulk-upload-slot]').querySelector('input[type="file"]') : remove.dataset.bulkRemoveFile === 'back' ? backArtwork : frontArtwork;
        var slot = builder.querySelector('[data-bulk-upload-slot="' + remove.dataset.bulkRemoveFile + '"]');
        if (removeInput) removeInput.value = '';
        if (slot) setFileState(slot, null);
      }
    });

    renderSharedOptions();
    renderPrintArea();
    renderColourPicker();
    renderBulkMatrix();
    updateArtworkSlots();
    syncProofChoice();
    restoreBulkEdit();
  }

  function initAllBulkBuilders() {
    document.querySelectorAll('[data-diy-bulk-builder]').forEach(initBulkBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBulkBuilders);
  } else {
    initAllBulkBuilders();
  }
  document.addEventListener('shopify:section:load', initAllBulkBuilders);
})();

